(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.lookbook-grid').forEach(function (grid) {
    var sectionId = grid.dataset.sectionId;
    var overlay = document.getElementById('pt-lightbox-' + sectionId);
    if (!overlay) return;

    var overlayImg = overlay.querySelector('img');
    var closeBtn = overlay.querySelector('.pt-lightbox-close');

    grid.querySelectorAll('[data-lightbox]').forEach(function (img) {
      img.addEventListener('click', function () {
        overlayImg.src = img.getAttribute('data-lightbox');
        overlayImg.alt = img.alt;
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    });

    function closeLightbox() {
      overlay.classList.remove('active');
      overlayImg.src = '';
      document.body.style.overflow = '';
    }

    closeBtn.addEventListener('click', closeLightbox);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
